<template>
  <div class="orderRequestListChild" style="background-color: white;    padding-bottom: 20px;">
    <div style="display:flex;padding: 19px 0 0 35px;">
      <div class="searchStatus" :class="searchStatus==0?'checkClass':''" @click="changeStatus(0)"><div class="jiao"></div>全部</div>
      <div class="searchStatus" style="background: #E7E6E6" @click="changeStatus(1)" :class="searchStatus==1?'checkClass':''">
        <div class="jiao" style="background: #F2F2F2" @click.stop="changeStatus(0)" :class="searchStatus==0?'checkClass':''"></div>
        <div >
          <p style="    margin-bottom: 5px;">待提起</p>
          <p>付款审核</p>
        </div>
      </div>
      <div class="searchStatus" :class="searchStatus==2?'checkClass':''" @click="changeStatus(2)">
        <div class="jiao" style="background: #E7E6E6" :class="searchStatus==1?'checkClass':''" @click.stop="changeStatus(1)"></div>
        <div>
          <p>审核中</p>
        </div>
      </div>
      <div class="searchStatus" style="background: white;width: 470px;">
        <div class="jiao" style="background: #F2F2F2" @click.stop="changeStatus(2)" :class="searchStatus==2?'checkClass':''"></div>
        <div>
          <div style="display: flex">
            <div class="searchStatusmin" style="    width: 220px;" :class="searchStatus==3?'checkClass':''" @click="changeStatus(3)">
              <div style="position: relative;">通过 待点击付款提醒给财<div class="jiao1" :class="searchStatus==3?'checkClass':''"></div></div>
            </div>
            <div class="searchStatusmin" :class="searchStatus==4?'checkClass':''" @click="changeStatus(4)">
              <div style="position: relative;"><div class="jiao2"></div>待付款
              <div class="jiao1" :class="searchStatus==4?'checkClass':''" style="    right: -46px;"></div></div>
            </div>
            <div class="searchStatusmin" :class="searchStatus==5?'checkClass':''" @click="changeStatus(5)">
              <div style="position: relative;">
                <div class="jiao2" style="left: -58px;"></div>已实付
                <div class="jiao1" style="right: -53px;" :class="searchStatus==5?'checkClass':''"></div></div>
            </div>
          </div>
          <div style="display: flex">
            <div class="searchStatusmin" :class="searchStatus==6?'checkClass':''" @click="changeStatus(6)">
              <div style="position: relative;">审核失败<div class="jiao1" style="    right: -44px;" :class="searchStatus==6?'checkClass':''"></div></div>
            </div>
            <div class="searchStatusmin" :class="searchStatus==7?'checkClass':''" @click="changeStatus(7)">
              <div style="position: relative;">
                <div class="jiao2" ></div>已作废
                <div class="jiao1" style="right: -53px;" :class="searchStatus==7?'checkClass':''"></div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="search">
      <p style="margin-bottom: 0.1rem;">
        <span>收款编号</span>
        <el-input v-model="searchObj.procureOrderNumber" style="width:134px"></el-input>
        <span>提请日期</span>
        <el-date-picker v-model="searchObj.createTime" type="date" style="width:120px"
          format="yyyy-MM-dd"></el-date-picker>
        <span>提请编号</span>
        <el-input v-model="searchObj.id" style="width:120px"></el-input>
        <span>金额</span>
        <el-input v-model="searchObj.price" style="width:100px"></el-input>
        <span>团号</span>
        <el-input v-model="searchObj.planId" style="width:60px"></el-input>
        <span>备注</span>
        <el-input v-model="searchObj.remark" style="width:160px"></el-input>
      </p>
      <p>
        <span>收款方名称</span>
        <el-input v-model="searchObj.payName" style="width:120px"></el-input>
        <span>付款日期</span>
        <el-date-picker v-model="searchObj.realPayDate" type="date" style="width:120px"
          format="yyyy-MM-dd"></el-date-picker>
        <span>提请人&nbsp;&nbsp;&nbsp;</span>
        <el-input v-model="searchObj.createName" style="width:120px"></el-input>
        <span>银行卡名称</span>
        <el-input v-model="searchObj.subjectName" style="width:167px"></el-input>
        <span>银行卡账号</span>
        <el-input v-model="searchObj.payBankNumber" style="width:120px"></el-input>
        <el-button type="primary" @click="getTableData('empty')">搜索</el-button>
      </p>
    </div>
    <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="提请编号" width="160">
        <template slot-scope="scope">
          <p><a style="color:blue">{{ scope.row.id }}</a></p>
        </template>
      </el-table-column>
      <el-table-column label="提请金额(原币)" width="100">
        <template slot-scope="scope">
          <p>{{ scope.row.yuanBiPrice }}</p>
        </template>
      </el-table-column>
      <el-table-column label="提请金额" width="100">
        <template slot-scope="scope">
          <p>{{ scope.row.price }}{{ scope.row.currency }}</p>
        </template>
      </el-table-column>
      <el-table-column label="付款金额(¥)" width="100">
        <template slot-scope="scope">
          <div>
            <p>{{ Number((scope.row.price * scope.row.rate).toFixed(2)) }}¥</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="审核状态" width="70">
        <template slot-scope="scope">
          <p v-if="scope.row.status == 0" style="color:red">未提审</p>
          <a v-else style="color:blue" @click="applyDetail(scope.row)">{{ scope.row.status == 0 ? '未提审' :
            scope.row.status == 1 ? '审核中' : scope.row.status == 2 ? '审核通过' : scope.row.status == 4 ? '已实付' :
              scope.row.status == 5 ? '已作废' : '被驳回' }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="payName" label="收款方名称" width="120"></el-table-column>
      <el-table-column prop="payBankName" label="收款账号名称" width="120"></el-table-column>
      <el-table-column prop="payBankNumber" label="收款银行账号" width="120"></el-table-column>
      <el-table-column prop="remark" label="备注" width="120"></el-table-column>
      <el-table-column prop="payDate" label="付款时间" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.realPayDate">{{ dateFormatYMD(scope.row.realPayDate, "-") }}</span>
          <span v-else>{{ dateFormatYMD(scope.row.payDate, "-") }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createName" label="提请人" width="120"></el-table-column>
      <el-table-column label="操作" fixed="right" width="160">
        <template slot-scope="scope">
          <div style="margin-bottom: 0.1rem;" v-if="scope.row.status!=5">
            <el-button v-if="scope.row.status == 0" size="mini" type="primary"
              @click="handleEdit(scope.row)">发起审批</el-button>
            <el-button v-else-if="scope.row.status == 1" size="mini" type="primary"
              @click="applyDetail(scope.row)">审批详情</el-button>
          </div>
          <!-- <div v-if="scope.row.sendPay == 0&&scope.row.status==2" style="margin-bottom: 0.1rem;">
            <el-button size="mini" type="primary" @click="sendPayNotice(scope.row)">发送付款提醒给财务</el-button>
          </div> -->
        </template>
      </el-table-column>
    </el-table>
    <pagination :totalNumber="totalNumber" @loadTable="loadTable"></pagination>
    <apply-detail :isRequest="true" ref="applyDetail"></apply-detail>
  </div>
</template>

<script>
import ApplyApi from "@/components/Api/apply.js";
import OrderApi from '@/components/Api/order.js'
import Pagination from '../../components/Pagination.vue'
import ApplyDetail from './components/applyDetail.vue';
export default {
  components: { Pagination, ApplyDetail, },
  props:{
    isDialog:{
      default:false,
      type:Boolean,
    }
  },
  data() {
    return {
      searchStatus: 0,
      searchObj: {
        status: null,//全部
        procureOrderNumber: null,
        id: null,
        ids: [],
        price: null,
        companyName: null,
        planId: null,
        state: null,
        createName: null,
        payName: null,
        createTime: null,
        sendPay: null,
        currency: null,
        subjectName: null,
        hasInvoice: null,
        realPayDate: null,
        isLink: null,
        requestType: null,
        remark:null,
        payBankNumber:null,
      },
      totalNumber: 0,
      tableData: [],
      page: 1,
      size: 10,
      editObj: {},
      titleName: '',
      changePayDate: null,
      applyDialogVisible1: false,
      returnPayRequestObj: {},
      returnPayRequestDialog: false,
      returnReason: '',
      billflowData: [],
      financeDialog: false,
    }
  },
  mounted(){
    if(!this.isDialog){
      this.changeStatus(0)
    }
  },
  methods: {
    changeStatus(status){
      this.searchStatus = status//0全部 1待提审 2 审核中 3 待发送提醒 4 待付款 5 已付款 6 审核不通过 7 作废
      if(this.searchStatus==0){
        this.searchObj.status=null
        this.searchObj.sendPay=null
      }else if(this.searchStatus==1){
        this.searchObj.status=0
        this.searchObj.sendPay=null
      }else if(this.searchStatus==2){
        this.searchObj.status=1
        this.searchObj.sendPay=null
      }else if(this.searchStatus==3){
        this.searchObj.status=2
        this.searchObj.sendPay=0
      }else if(this.searchStatus==4){
        this.searchObj.status=2
        this.searchObj.sendPay=1
      }else if(this.searchStatus==5){
        this.searchObj.status=4
        this.searchObj.sendPay=null
      }else if(this.searchStatus==6){
        this.searchObj.status=3
        this.searchObj.sendPay=null
      }else if(this.searchStatus==7){
        this.searchObj.status=5
        this.searchObj.sendPay=null
      }
      this.getTableData('empty')
    },
    getTableData(type) {
      this.searchObj.requestType=4
      if (type == 'empty') {
        this.page = 1
      }
      new OrderApi('order').orderPayRequestList({ page: this.page, size: this.size, q: this.searchObj }).then(res => {
        if (res.status == 200) {
          this.tableData = res.data.records
          this.searchObj.ids = []
          this.totalNumber = res.data.total
        }
      })
    },
    sendPayNotice(item) {
      new OrderApi('order').sendPayNotice(item.id).then(res => {
        if (res.status == 200) {
          this.$message.success({ message: "已发送付款通知信息给财务" })
          this.getTableData('empty')
        } else {
          this.$message.error({ message: res.statusText })
        }
      })
    },
    loadTable(page, size) {
      this.page = page
      this.size = size
      this.getTableData()
    },
    handleEdit(row) {
      if (row.payType == 1) {
        new OrderApi('order').orderPayRequestApply(row.id).then(res1 => {
          if (res1.status == 200) {
            this.$message.success({ message: "已成功发起审批" })
            this.sendWechatInfo(row.id)
            row.status = 1;
          } else {
            this.$message.error({ message: res1.statusText })
          }
        })
      } else {
        new OrderApi('order').orderPayRequestApplyDai(row.id).then(res1 => {
          if (res1.status == 200) {
            this.$message.success({ message: "已成功发起审批" })
            this.sendWechatInfo(row.id)
            row.status = 1;
          } else {
            this.$message.error({ message: res1.statusText })
          }
        })
      }
    },
    sendWechatInfo(id) {
      new ApplyApi('apply').firstSendApproval(id).then(res => {
        if (res.status == 200) {
          this.$message.success({ message: "微信公众号审核提醒发送成功" })
        } else {
          this.$message.error({ message: res.statusText })
        }
      })
    },
    applyDetail(item) {
      this.$refs.applyDetail.beforeOpen(item)
    },
  },
}
</script>

<style lang='scss' scoped>
.checkClass{
  background: #C00000 !important;
  color: white !important;
}
.searchStatusmin{
  .jiao1{
    width: 24px;
    height: 24px;
    transform: rotate(135deg);
    right: -40px;
    position: absolute;
    top: -3px;
    background-color: #E7E6E6;
    z-index: 10;
  }
  .jiao2{
    width: 27px;
    height: 27px;
    transform: rotate(135deg);
    left: -54px;
    top: -5px;
    position: absolute;
    background-color: white;
    z-index: 0;
  }
  background: #E7E6E6;
  color: #242424;
  font-weight: bold;
  width: 125px;
  height: 34px;
  justify-content: center;
  display: flex;
  align-items: center;
  margin-bottom: 3px;
}
.searchStatus{
  .jiao{
    background-color: white;
    width: 50px;
    height: 50px;
    position: absolute;
    top: 10px;
    left: -26px;
    transform: rotate(135deg);
  }
  background: #F2F2F2;
  color: #242424;
  font-weight: bold;
  width: 125px;
  height: 70px;
  justify-content: center;
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 10px;
}
.search {
  margin-bottom: 0.1rem;
  font-size: 0.14rem;
  padding-left: 32px;
  >p {
    >span {
      margin-right: 0.1rem;
    }

    >div {
      margin-right: 0.1rem;
    }
  }
}
</style>
<style>
.orderRequestListChild .el-table td,
.el-table th {
  text-align: center !important;
  color: black;
}
</style>